import { createPinia } from 'pinia'
import { createApp } from 'vue'
import { createApi, resolveApiBaseUrl } from '@loczi/api'
import { useSessionStore } from '@loczi/auth'
import { setLabelResolver } from '@loczi/features'
import { applyUserLocale, createLocziI18n, type LocaleComposer } from '@loczi/i18n'
import '@loczi/ui/tokens.css'
import App from './App.vue'
import { router } from './router'

const i18n = createLocziI18n({
  // Troca de idioma autenticada persiste no perfil (Accept-Language segue).
  persist: (locale) => session.isAuthenticated
    ? api.auth.updateLocale({ locale }).catch(() => {})
    : undefined,
})

// Labels de enum/formatters do @loczi/features falam o idioma do vue-i18n.
setLabelResolver((key, params) => (i18n.global as unknown as LocaleComposer).t(key, params))

const api = createApi({
  baseUrl: resolveApiBaseUrl(import.meta.env.VITE_API_URL, import.meta.env.VITE_API_URL_PUBLIC),
  variant: 'admin',
  getLocale: () => (i18n.global.locale as { value: string }).value,
  onUnauthorized: () => {
    // Expira o estado local antes de navegar — senão o guard vê a sessão
    // ainda válida em memória e devolve para a rota atual (loop de 401).
    session.expire()
    router.push({ name: 'login' })
  },
})

const app = createApp(App)
const pinia = createPinia()
app.use(pinia)
app.use(i18n)

const session = useSessionStore(pinia)
session.bind(api)
await session.bootstrap()

// Preferência do perfil vence o storage local quando existe.
await applyUserLocale(i18n, session.user?.locale, (locale) => {
  void api.auth.updateLocale({ locale }).catch(() => {})
})

app.use(router)
app.mount('#app')
